import Swiper from "../../../../../vendor/swiper/swiper-bundle.esm.browser";

export default class {
    constructor($el) {
        this.$el = $el;
        this.swiper = this.swiper.bind(this);
        this.swiper();
    }

    swiper() {
        var swiper = new Swiper(this.$el, {
            direction: "vertical",
            loop: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
        });
    }
}